import type {
  DeleteManySessionsResponse,
  ListResponseDto,
  ListTicketSessionsResponse,
  SessionDto,
  TicketDto,
  VerifySessionsResponse,
} from '@linka/domain/dtos';
import type {
  BulkUpdateSessionsStatusRequest,
  CreateRecurrenceSessionsRequest,
  CreateSessionRequest,
  DeleteManySessionsRequest,
  UpdateRecurrenceSessionsRequest,
  UpdateSessionRequest,
  UpdateSessionStatusRequest,
  VerifySessionsRequest,
} from '@linka/domain/requests';
import { httpRequest } from '../client/http';

export const ticketController = {
  list: httpRequest<unknown, ListResponseDto<TicketDto>>('get', 'event/:eventId/ticket/admin'),
  listPublic: httpRequest<unknown, ListResponseDto<TicketDto>>('get', 'event/:eventId/ticket'),
  listSessions: httpRequest<unknown, SessionDto[]>('get', 'event/:eventId/ticket/:ticketId/session'),
  createSession: httpRequest<CreateSessionRequest, SessionDto>('post', 'event/:eventId/ticket/:ticketId/session'),
  updateSession: httpRequest<UpdateSessionRequest, SessionDto>(
    'put',
    'event/:eventId/ticket/:ticketId/session/:sessionId',
  ),
  updateSessionStatus: httpRequest<UpdateSessionStatusRequest, SessionDto>(
    'patch',
    'event/:eventId/ticket/:ticketId/session/:sessionId/status',
  ),
  updateSessionsStatus: httpRequest<BulkUpdateSessionsStatusRequest, SessionDto[]>(
    'patch',
    'event/:eventId/ticket/:ticketId/session/bulk/status',
  ),
  deleteSession: httpRequest('delete', 'event/:eventId/ticket/:ticketId/session/:sessionId'),
  deleteManySessions: httpRequest<DeleteManySessionsRequest, DeleteManySessionsResponse>(
    'delete',
    'event/:eventId/ticket/:ticketId/session/bulk',
  ),
  createRecurrenceSessions: httpRequest<CreateRecurrenceSessionsRequest, SessionDto[]>(
    'post',
    'event/:eventId/ticket/:ticketId/session/recurrence',
  ),
  updateRecurrenceSessions: httpRequest<UpdateRecurrenceSessionsRequest, SessionDto[]>(
    'patch',
    'event/:eventId/ticket/:ticketId/session/recurrence/:recurrenceId',
  ),
  previewRecurrenceSessions: httpRequest<CreateRecurrenceSessionsRequest, SessionDto[]>(
    'post',
    'event/:eventId/ticket/:ticketId/session/recurrence/preview',
  ),
  listPublicSessions: httpRequest<unknown, ListTicketSessionsResponse>(
    'get',
    'event/:eventId/ticket/:ticketId/sessions',
  ),
  verifySessions: httpRequest<VerifySessionsRequest, VerifySessionsResponse>(
    'post',
    'event/:eventId/ticket/sessions/verify',
  ),
};
